import { StatusContext } from "components/context/StatusContextProvider";
import { OnboardingModule } from "components/common/OnboardingModule";
import { OnboardingTask } from "components/common/OnboardingTypes";
import { useContext } from "react";

export default () => {
  const { onboardingModuleState } = useContext(StatusContext);

  if (!onboardingModuleState) return null;

  const tasks: OnboardingTask[] = [
    {
      label: "Attend an onboarding and review resources",
      completed: onboardingModuleState.hasOnboarded,
      url: "/community/resources?from=onboarding",
    },
    {
      label: "Fill out the matchmaking questionnaire",
      completed: onboardingModuleState.hasCompletedMatchmakingQuestionnaire,
      url: "/forms/complete/3e07784a-f3fb-412e-aefb-d9be4a4677ec",
    },
    {
      label: "Write your profile bio",
      completed: onboardingModuleState.hasCompletedBio,
      url: "/settings?from=onboarding",
    },
    {
      label: "Install the web app and enable notifications",
      completed: onboardingModuleState.hasInstalledApp,
      url: "https://advisor.findfaye.com/documents/3e9aebd4-67af-44c0-acad-bf03d0202ce2",
    },
    {
      label: "Create your test family",
      completed: onboardingModuleState.hasCreatedTestFamily,
      url: "/families?from=onboarding&addTestFamily=true",
    },
  ];

  return (
    <OnboardingModule
      tasks={tasks}
      title="Your first Faye to-do list"
      subtitle="Complete these to get matched faster and make the most of Faye."
      dismissKey="faye-onboarding-dismissed"
      dismissDays={3}
    />
  );
};
